// canvas/CanvasSVG.jsx
import React from 'react';

/**
 * CanvasSVG - renders the SVG and shape layers.
 * (No pan/transform here — pan is applied on frame-container.)
 */
const CanvasSVG = ({
  renderKey,
  fixedCanvasSize,
  layerSettings,
  getRadiusForLayer,
  generateGradientDef,
  generateShapes,
  getRandomColor,
}) => {
  const center = fixedCanvasSize / 2;

  return (
    <svg
      key={renderKey}
      width={fixedCanvasSize}
      height={fixedCanvasSize}
      viewBox={`0 0 ${fixedCanvasSize} ${fixedCanvasSize}`}
      xmlns="http://www.w3.org/2000/svg"
      onContextMenu={(e) => e.preventDefault()}
      style={{ pointerEvents: 'none' }}
      shapeRendering="geometricPrecision"
    >
      <defs>
        {layerSettings.map((layer, index) =>
          layer.colorData?.type !== 'solid'
            ? generateGradientDef(index, layer.colorData, getRadiusForLayer(layer, fixedCanvasSize, 100), fixedCanvasSize)
            : null
        )}
      </defs>

      {[...layerSettings].reverse().map((layer, indexReversed) => {
        const actualIndex = layerSettings.length - 1 - indexReversed;
        if (layer.showItem === false) return null;

        // compute rotation offset: minus of (360 / numShapes)
        // guard against zero or undefined numShapes
        const n = layer.numShapes && layer.numShapes > 0 ? layer.numShapes : 1;
        const rotateDeg = -90;

        // If you only want to apply the correction for polygon shapes (not circles),
        // uncomment the next line and use it as the transform conditionally:
        // const applyTransform = layer.shapeType !== 'circle' && n > 1;
        const applyTransform = n > 1; // apply for any layer with more than 1 shape
        const strokeSize = Number(layer.strokeWidth)  ?? 1;

        return (
          <g
            vectorEffect="non-scaling-stroke"
            key={actualIndex}
            style={{ mixBlendMode: layer.blendMode }}
            stroke={
              layer.colorData?.type === 'solid'
                ? layer.colorData.color || layer.colorData.color1 || getRandomColor()
                : `url(#gradient-${actualIndex})`
            }
            opacity={layer.opacity / 100}
            
            strokeWidth={layer.numShapes > 1000 ? 0.1 : strokeSize*0.9}
            // apply rotation about the canvas center when needed
            transform={applyTransform ? `rotate(${rotateDeg} ${center} ${center})` : undefined}
          >
            {generateShapes(layer, 100, fixedCanvasSize)}
          </g>
        );
      })}
    </svg>
  );
};

export default CanvasSVG;
